<template>
  <div>
    <automationRemover ref="automationRemover"></automationRemover>
    <vs-prompt
      :title="currentAutomationName"
      color="warning"
      @accept="updateAutomation"
      @close="clearFields"
      :active.sync="showEditPrompt"
      accept-text="Yes, Update"
    >
      <vs-alert active="true" color="warning" icon="info"> You can modify details such as description, retrigger endpoint. </vs-alert>
      <vs-divider color="warning">Automation Details</vs-divider>
      <vs-input label="Discription" placeholder="Enter automation description" class="my-2 w-full mb-4" v-model="currentAutomationData.tooltip" />

      <vs-input
        label="Retrigger URL"
        placeholder="Enter automation retrigger URL"
        class="my-2 w-full mb-4"
        v-model="currentAutomationData.retriggerUrls.new[0]"
      />

      <vs-divider color="danger">Delete Automation</vs-divider>

      <div class="deleteAutomationContainer">
        <vs-alert active="true" color="danger" icon="info"> Deletion is an irreversible process, please proceed with caution. </vs-alert>
        <vs-button @click="deleteAutomation" class="deleteAutomationButton" color="danger" type="relief">Delete Automation</vs-button>
      </div>

      <vs-divider v-if="this.$store.state.admin.access === true" color="warning">Assignee Details</vs-divider>

      <div v-if="this.$store.state.admin.access === true">
        <vs-alert active="true" color="danger" icon="info"> Assignee is the person responsible for development and maintenance of the workflow </vs-alert>
        <vs-input class="assigneeInputField" placeholder="Enter assignee email address" v-model="currentAutomationData.assignee" />
      </div>
    </vs-prompt>
  </div>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/firestore'
import automationRemover from './automationRemover.vue'

export default {
  name: 'automationEditor',
  components: { automationRemover },
  data() {
    return {
      showEditPrompt: false,
      currentAutomationName: '',
      currentAutomationData: {
        assignee: 'am@cloudify.biz',
        retriggerUrls: {
          new: ['Enter Retrigger URL'],
        },
        tooltip: 'Enter ToolTip',
      },
    }
  },
  methods: {
    editAutomationDetails(automationName, automationData) {
      this.showEditPrompt = true
      this.currentAutomationName = automationName
      this.currentAutomationData = JSON.parse(JSON.stringify(automationData))
    },
    async updateAutomation() {
      const automationDetailsHolder = {
        assignee: this.currentAutomationData.assignee,
        retriggerUrls: {
          new: [this.currentAutomationData.retriggerUrls.new[0]],
        },
        tooltip: this.currentAutomationData.tooltip,
      }

      await firebase
        .firestore()
        .collection('cloudify')
        .doc(JSON.parse(localStorage.getItem('userInfo')).uid)
        .set({ sheets: { [`${this.currentAutomationName}`]: automationDetailsHolder } }, { merge: true })
    },
    clearFields() {},
    deleteAutomation() {
      this.showEditPrompt = false
      this.$refs.automationRemover.deleteAutomationToggler(this.currentAutomationName)
    },
  },
}
</script>

<style scoped>
.deleteAutomationContainer {
  margin: 0.5em 0 0.5em 0;
}
.deleteAutomationButton {
  margin-top: 0.5em;
  width: 100%;
}
.assigneeInputField {
  margin-top: 1em;
  width: 100%;
}
</style>
